import { apiRequest } from '../../../services/api'
import { ETFHoldingDataType, GetETFHoldingsResponseDataType } from './types'

export function getEtfHoldingsRequest<T extends ETFHoldingDataType>(type: T, ticker: string) {
  const pathBase = `/api/etf_holdings/${ticker}`

  switch (type) {
    case ETFHoldingDataType.Breakdown:
      return apiRequest<GetETFHoldingsResponseDataType<T>>(`${pathBase}/breakdown`)
    case ETFHoldingDataType.TopTen:
      return apiRequest<GetETFHoldingsResponseDataType<T>>(`${pathBase}/top_ten`)
    case ETFHoldingDataType.Full:
      return apiRequest<GetETFHoldingsResponseDataType<T>>(pathBase)
    default:
      throw new Error('Invalid ETFHoldings request type provided')
  }
}
